/*
 *  Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import moment from "moment";
import _get from "lodash/get";
import _has from "lodash/has";
import { FieldType } from "../types/formatServiceTypes/FieldType";
import { translate } from "./translations/translations";

export const eur = (val: number) => {
  return val.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
};

export const momentToGermanDate = (value: string) => (moment(value).isValid() ? moment(value).format("DD.MM.YYYY") : value);

export function convertValueDependingOnFieldType(caseData: Record<string, any>, fieldPath: string, fieldType: FieldType) {
  if (!fieldType) {
    return _get(caseData, fieldPath);
  }

  switch (fieldType) {
    case "date":
      return momentToGermanDate(_get(caseData, fieldPath));
    case "money":
      return eur(parseInt(_get(caseData, fieldPath)));
    case "dateMY":
      return moment(_get(caseData, fieldPath)).format("MMMM YYYY");
    case "yesNo":
      return _get(caseData, fieldPath) === true ? "Ja" : "Nein";
    case "time":
      return moment(_get(caseData, fieldPath)).format("HH:mm");
    case "multipleOptions":
      const selectedOptions = _get(caseData, fieldPath);

      return selectedOptions
        .map((selectedOption: string) => translate(`${caseData.name}.${fieldPath}.options.${selectedOption}.label`, caseData, _get(caseData, fieldPath)))
        .join(", ");
  }
}

export function fieldPathValueCanBeDisplayed(caseData: any, fieldPath: string): boolean {
  return !(!_has(caseData, fieldPath) || _get(caseData, fieldPath) === null);
}
